import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@mui/material';
import clsx from 'clsx';
import { useBackgroundClass } from '../../../styles/jss/utils';
import useStyles from './SubMessageTitle.styles';
const SubMessageTitle = (props) => {
    const { subMessageBackgroundColor, subMessageTitle, subMessage, isSubHeading, classNames } = props;
    const { classes } = useStyles({ isSubHeading: isSubHeading });
    const { bgClass } = useBackgroundClass(subMessageBackgroundColor);
    return (_jsx(Box, { className: clsx(bgClass, classes.subMessageContainer, ...[classNames !== null && classNames !== void 0 ? classNames : []]), children: !!subMessageTitle || !!subMessage ? (_jsxs(_Fragment, { children: [subMessageTitle && _jsxs("span", { className: classes === null || classes === void 0 ? void 0 : classes.subMessageTitle, children: [subMessageTitle, "\u00A0"] }), subMessage && _jsx("span", { className: classes === null || classes === void 0 ? void 0 : classes.subMessage, children: subMessage })] })) : null }));
};
export default SubMessageTitle;
